module.exports = __webpack_public_path__ + "fonts/NetflixSansBlack.32c5ff37.ttf";